import React from 'react';
import "../../styles/global-hero.css";

const Hero = () => {
    return (
        <div className="global-hero">
            <div className="container text-center">
                <h1>College Syllabus</h1>
                <p>Home &gt;  College Syllabus</p>
            </div>
        </div>
    )
}

export default Hero;